const COLOR_SCHEMES = {
	Adjacency6: ["#a9a57c", "#9cbebd", "#d2cb6c", "#95a39d", "#c89f5d", "#b1a089"],
	Advantage6: ["#663366", "#330f42", "#666699", "#999966", "#f7901e", "#a3a101"],
	Angles6: ["#797b7e", "#f96a1b", "#08a1d9", "#7c984a", "#c2ad8d", "#506e94"],
	Apex6: ["#ceb966", "#9cb084", "#6bb1c9", "#6585cf", "#7e6bc9", "#a379bb"],
	Apothecary6: ["#93a299", "#cf543f", "#b5ae53", "#848058", "#e8b54d", "#786c71"],
	Aspect6: ["#f07f09", "#9f2936", "#1b587c", "#4e8542", "#604878", "#c19859"],
	Atlas6: ["#f81b02", "#fc7715", "#afbf41", "#50c49f", "#3b95c4", "#b560d4"],
	Austin6: ["#94c600", "#71685a", "#ff6700", "#909465", "#956b43", "#fea022"],
	Badge6: ["#f8b323", "#656a59", "#46b2b5", "#8caa7e", "#d36f68", "#826276"],
	Banded6: ["#ffc000", "#a5d028", "#08cc78", "#f24099", "#828288", "#f56617"],
	Basis6: ["#f09415", "#c1b56b", "#4baf73", "#5aa6c0", "#d17df9", "#fa7e5c"],
	Berlin6: ["#a6b727", "#df5327", "#fe9e00", "#418ab3", "#d7d447", "#818183"],
	BlackTie6: ["#6f6f74", "#a7b789", "#beae98", "#92a9b9", "#9c8265", "#8d6974"],
	Blue6: ["#0f6fc6", "#009dd9", "#0bd0d9", "#10cf9b", "#7cca62", "#a5c249"],
	BlueGreen6: ["#3494ba", "#58b6c0", "#75bda7", "#7a8c8e", "#84acb6", "#2683c6"],
	BlueII6: ["#1cade4", "#2683c6", "#27ced7", "#42ba97", "#3e8853", "#62a39f"],
	BlueRed6: ["#4a66ac", "#629dd1", "#297fd5", "#7f8fa9", "#5aa2ae", "#9d90a0"],
	BlueWarm6: ["#4a66ac", "#629dd1", "#297fd5", "#7f8fa9", "#5aa2ae", "#9d90a0"],
	Breeze6: ["#2c7c9f", "#244a58", "#e2751d", "#ffb400", "#7eb606", "#c00000"],
	Capital6: ["#4b5a60", "#9c5238", "#504539", "#c1ad79", "#667559", "#bad6ad"],
	Celestial6: ["#ac3ec1", "#477bd1", "#46b298", "#90ba4c", "#dd9d31", "#e25247"],
	Circuit6: ["#9acd4c", "#faa93a", "#d35940", "#b258d3", "#63a0cc", "#8ac4a7"],
	Civic6: ["#d16349", "#ccb400", "#8cadae", "#8c7b70", "#8fb08c", "#d19049"],
	Clarity6: ["#93a299", "#ad8f67", "#726056", "#4c5a6a", "#808da0", "#79463d"],
	Codex6: ["#990000", "#efab16", "#78ac35", "#35aca2", "#4083cf", "#0d335e"],
	Composite6: ["#98c723", "#59b0b9", "#deae00", "#b77bb4", "#e0773c", "#a98d63"],
	Concourse6: ["#2da2bf", "#da1f28", "#eb641b", "#39639d", "#474b78", "#7d3c4a"],
	Couture6: ["#9e8e5c", "#a09781", "#85776d", "#aeafa9", "#8d878b", "#6b6149"],
	Crop6: ["#8c8d86", "#e6c069", "#897b61", "#8dab8e", "#77a2bb", "#e28394"],
	Damask6: ["#9ec544", "#50bea3", "#4a9ccc", "#9a66ca", "#c54f71", "#de9c3c"],
	Depth6: ["#41aebd", "#97e9d5", "#a2cf49", "#608f3d", "#f4de3a", "#fcb11c"],
	Dividend6: ["#4d1434", "#903163", "#b2324b", "#969fa7", "#66b1ce", "#40619d"],
	Droplet6: ["#2fa3ee", "#4bcaad", "#86c157", "#d99c3f", "#ce6633", "#a35dd1"],
	Elemental6: ["#629dd1", "#297fd5", "#7f8fa9", "#4a66ac", "#5aa2ae", "#9d90a0"],
	Equity6: ["#d34817", "#9b2d1f", "#a28e6a", "#956251", "#918485", "#855d5d"],
	Essential6: ["#7a7a7a", "#f5c201", "#526db0", "#989aac", "#dc5924", "#b4b392"],
	Excel16: [
		"#9999ff",
		"#993366",
		"#ffffcc",
		"#ccffff",
		"#660066",
		"#ff8080",
		"#0066cc",
		"#ccccff",
		"#000080",
		"#ff00ff",
		"#ffff00",
		"#0000ff",
		"#800080",
		"#800000",
		"#008080",
		"#0000ff",
	],
	Executive6: ["#6076b4", "#9c5252", "#e68422", "#846648", "#63891f", "#758085"],
	Exhibit6: ["#3399ff", "#69ffff", "#ccff33", "#3333ff", "#9933ff", "#ff33ff"],
	Expo6: ["#fbc01e", "#efe1a2", "#fa8716", "#be0204", "#640f10", "#7e13e3"],
	Facet6: ["#90c226", "#54a021", "#e6b91e", "#e76618", "#c42f1a", "#918655"],
	Feathered6: ["#606372", "#79a8a4", "#b2ad8f", "#ad8082", "#dec18c", "#92a185"],
	Flow6: ["#0f6fc6", "#009dd9", "#0bd0d9", "#10cf9b", "#7cca62", "#a5c249"],
	Focus6: ["#ffb91d", "#f97817", "#6de304", "#ff0000", "#732bea", "#c913ad"],
	Folio6: ["#294171", "#748cbc", "#8e887c", "#834736", "#5a1705", "#a0a16a"],
	Formal6: ["#907f76", "#a46645", "#cd9c47", "#9a92cd", "#7d639b", "#733678"],
	Forte6: ["#c70f0c", "#dd6b0d", "#faa700", "#93e50d", "#17c7ba", "#0a96e4"],
	Foundry6: ["#72a376", "#b0ccb0", "#a8cdd7", "#c0beaf", "#cec597", "#e8b7b7"],
	Frame6: ["#40bad2", "#fab900", "#90bb23", "#ee7008", "#1ab39f", "#d5393d"],
	Gallery6: ["#b71e42", "#de478e", "#bc72f0", "#795faf", "#586ea6", "#6892a0"],
	Genesis6: ["#80b606", "#e29f1d", "#2397e2", "#35aca2", "#5430bb", "#8d34e0"],
	Grayscale6: ["#dddddd", "#b2b2b2", "#969696", "#808080", "#5f5f5f", "#4d4d4d"],
	Green6: ["#549e39", "#8ab833", "#c0cf3a", "#029676", "#4ab5c4", "#0989b1"],
	GreenYellow6: ["#99cb38", "#63a537", "#37a76f", "#44c1a3", "#4eb3cf", "#51c3f9"],
	Grid6: ["#c66951", "#bf974d", "#928b70", "#87706b", "#94734e", "#6f777d"],
	Habitat6: ["#f8c000", "#f88600", "#f83500", "#8b723d", "#818b3d", "#586215"],
	Hardcover6: ["#873624", "#d6862d", "#d0be40", "#877f6c", "#972109", "#aeb795"],
	Headlines6: ["#439eb7", "#e28b55", "#dcb64d", "#4ca198", "#835b82", "#645135"],
	Horizon6: ["#7e97ad", "#cc8e60", "#7a6a60", "#b4936d", "#67787b", "#9d936f"],
	Infusion6: ["#8c73d0", "#c2e8c4", "#c5a6e8", "#b45ec7", "#9fdafb", "#95c5b0"],
	Inkwell6: ["#860908", "#4a0505", "#7a500a", "#c47810", "#827752", "#b5bb83"],
	Inspiration6: ["#749805", "#bacc82", "#6e9ec2", "#2046a5", "#5039c6", "#7411d0"],
	Integral6: ["#1cade4", "#2683c6", "#27ced7", "#42ba97", "#3e8853", "#62a39f"],
	Ion6: ["#b01513", "#ea6312", "#e6b729", "#6aac90", "#5f9c9d", "#9e5e9b"],
	IonBoardroom6: ["#b31166", "#e33d6f", "#e45f3c", "#e9943a", "#9b6bf2", "#d53dd0"],
	Kilter6: ["#76c5ef", "#fea022", "#ff6700", "#70a525", "#a5d848", "#20768c"],
	Madison6: ["#a1d68b", "#5ec795", "#4dadcf", "#cdb756", "#e29c36", "#8ec0c1"],
	MainEvent6: ["#b80e0f", "#a6987d", "#7f9a71", "#64969f", "#9b75b2", "#80737a"],
	Marquee6: ["#418ab3", "#a6b727", "#f69200", "#838383", "#fec306", "#df5327"],
	Median6: ["#94b6d2", "#dd8047", "#a5ab81", "#d8b25c", "#7ba79d", "#968c8c"],
	Mesh6: ["#6f6f6f", "#bfbfa5", "#dcd084", "#e7bf5f", "#e9a039", "#cf7133"],
	Metail6: ["#6283ad", "#324966", "#5b9ea4", "#1d5b57", "#1b4430", "#2f3c35"],
	Metro6: ["#7fd13b", "#ea157a", "#feb80a", "#00addc", "#738ac8", "#1ab39f"],
	Metropolitan6: ["#50b4c8", "#a8b97f", "#9b9256", "#657689", "#7a855d", "#84ac9d"],
	Module6: ["#f0ad00", "#60b5cc", "#e66c7d", "#6bb76d", "#e88651", "#c64847"],
	NewsPrint6: ["#ad0101", "#726056", "#ac956e", "#808da9", "#424e5b", "#730e00"],
	Office6: ["#5b9bd5", "#ed7d31", "#a5a5a5", "#ffc000", "#4472c4", "#70ad47"],
	OfficeClassic6: ["#4f81bd", "#c0504d", "#9bbb59", "#8064a2", "#4bacc6", "#f79646"],
	Opulent6: ["#b83d68", "#ac66bb", "#de6c36", "#f9b639", "#cf6da4", "#fa8d3d"],
	Orange6: ["#e48312", "#bd582c", "#865640", "#9b8357", "#c2bc80", "#94a088"],
	OrangeRed6: ["#d34817", "#9b2d1f", "#a28e6a", "#956251", "#918485", "#855d5d"],
	Orbit6: ["#f2d908", "#9de61e", "#0d8be6", "#c61b1b", "#e26f08", "#8d35d1"],
	Organic6: ["#83992a", "#3c9770", "#44709d", "#a23c33", "#d97828", "#deb340"],
	Oriel6: ["#fe8637", "#7598d9", "#b32c16", "#f5cd2d", "#aebad5", "#777c84"],
	Origin6: ["#727ca3", "#9fb8cd", "#d2da7a", "#fada7a", "#b88472", "#8e736a"],
	Paper6: ["#a5b592", "#f3a447", "#e7bc29", "#d092a7", "#9c85c0", "#809ec2"],
	Parallax6: ["#30acec", "#80c34f", "#e29d3e", "#d64a3b", "#d64787", "#a666e1"],
	Parcel6: ["#f6a21d", "#9bafb5", "#c96731", "#9ca383", "#87795d", "#a0988c"],
	Perception6: ["#a2c816", "#e07602", "#e4c402", "#7dc1ef", "#21449b", "#a2b170"],
	Perspective6: ["#838d9b", "#d2610c", "#80716a", "#94147c", "#5d5ad2", "#6f6c7d"],
	Pixel6: ["#ff7f01", "#f1b015", "#fbec85", "#d2c2f1", "#da5af4", "#9d09d1"],
	Plaza6: ["#990000", "#580101", "#e94a00", "#eb8f00", "#a4a4a4", "#666666"],
	Precedent6: ["#993232", "#9b6c34", "#736c5d", "#c9972b", "#c95f2b", "#8f7a05"],
	Pushpin6: ["#fda023", "#aa2b1e", "#71685c", "#64a73b", "#eb5605", "#b9ca1a"],
	Quotable6: ["#00c6bb", "#6feba0", "#b6df5e", "#efb251", "#ef755f", "#ed515c"],
	Red6: ["#a5300f", "#d55816", "#e19825", "#b19c7d", "#7f5f52", "#b27d49"],
	RedOrange6: ["#e84c22", "#ffbd47", "#b64926", "#ff8427", "#cc9900", "#b22600"],
	RedViolet6: ["#e32d91", "#c830cc", "#4ea6dc", "#4775e7", "#8971e1", "#d54773"],
	Retrospect6: ["#e48312", "#bd582c", "#865640", "#9b8357", "#c2bc80", "#94a088"],
	Revolution6: ["#0c5986", "#ddf53d", "#508709", "#bf5e00", "#9c0001", "#660075"],
	Saddle6: ["#c6b178", "#9c5b14", "#71b2bc", "#78aa5d", "#867099", "#4c6f75"],
	Savon6: ["#1cade4", "#2683c6", "#27ced7", "#42ba97", "#3e8853", "#62a39f"],
	Sketchbook6: ["#a63212", "#e68230", "#9bb05e", "#6b9bc7", "#4e66b2", "#8976ac"],
	Sky6: ["#073779", "#8fd9fb", "#ffcc00", "#eb6615", "#c76402", "#b523b4"],
	Slate6: ["#bc451b", "#d3ba68", "#bb8640", "#ad9277", "#a55a43", "#ad9d7b"],
	Slice6: ["#052f61", "#a50e82", "#14967c", "#6a9e1f", "#e87d37", "#c62324"],
	Slipstream6: ["#4e67c8", "#5eccf3", "#a7ea52", "#5dceaf", "#ff8021", "#f14124"],
	SOHO6: ["#61625e", "#964d2c", "#66553e", "#848058", "#afa14b", "#ad7d4d"],
	Solstice6: ["#3891a7", "#feb80a", "#c32d2e", "#84aa33", "#964305", "#475a8d"],
	Spectrum6: ["#990000", "#ff6600", "#ffba00", "#99cc00", "#528a02", "#333333"],
	Story6: ["#1d86cd", "#732e9a", "#b50b1b", "#e8950e", "#55992b", "#2c9c89"],
	Studio6: ["#f7901e", "#fec60b", "#9fe62f", "#4ea5d1", "#1c4596", "#542d90"],
	Summer6: ["#51a6c2", "#51c2a9", "#7ec251", "#e1dc53", "#b54721", "#a16bb1"],
	Technic6: ["#6ea0b0", "#ccaf0a", "#8d89a4", "#748560", "#9e9273", "#7e848d"],
	Thatch6: ["#759aa5", "#cfc60d", "#99987f", "#90ac97", "#ffad1c", "#b9ab6f"],
	Tradition6: ["#6b4a0b", "#790a14", "#908342", "#423e5c", "#641345", "#748a2f"],
	Travelogue6: ["#b74d21", "#a32323", "#4576a3", "#615d9a", "#67924b", "#bf7b1b"],
	Trek6: ["#f0a22e", "#a5644e", "#b58b80", "#c3986d", "#a19574", "#c17529"],
	Twilight6: ["#e8bc4a", "#83c1c6", "#e78d35", "#909ce1", "#839c41", "#cc5439"],
	Urban6: ["#53548a", "#438086", "#a04da3", "#c4652d", "#8b5d3d", "#5c92b5"],
	UrbanPop6: ["#86ce24", "#00a2e6", "#fac810", "#7d8f8c", "#d06b20", "#958b8b"],
	VaporTrail6: ["#df2e28", "#fe801a", "#e9bf35", "#81bb42", "#32c7a9", "#4a9bdc"],
	Venture6: ["#9eb060", "#d09a08", "#f2ec86", "#824f1c", "#511818", "#553876"],
	Verve6: ["#ff388c", "#e40059", "#9c007f", "#68007f", "#005bd3", "#00349e"],
	View6: ["#6f6f74", "#92a9b9", "#a7b789", "#b9a489", "#8d6374", "#9b7362"],
	Violet6: ["#ad84c6", "#8784c7", "#5d739a", "#6997af", "#84acb6", "#6f8183"],
	VioletII6: ["#92278f", "#9b57d3", "#755dd9", "#665eb8", "#45a5ed", "#5982db"],
	Waveform6: ["#31b6fd", "#4584d3", "#5bd078", "#a5d028", "#f5c040", "#05e0db"],
	Wisp6: ["#a53010", "#de7e18", "#9f8351", "#728653", "#92aa4c", "#6aac91"],
	WoodType6: ["#d34817", "#9b2d1f", "#a28e6a", "#956251", "#918485", "#855d5d"],
	Yellow6: ["#ffca08", "#f8931d", "#ce8d3e", "#ec7016", "#e64823", "#9c6a6a"],
	YellowOrange6: ["#f0a22e", "#a5644e", "#b58b80", "#c3986d", "#a19574", "#c17529"],
};
export default COLOR_SCHEMES;

export const APP_ASSIGN_COLOR_SCHEME = [
	...COLOR_SCHEMES.Office6,
	...COLOR_SCHEMES.Elemental6,
	...COLOR_SCHEMES.Equity6,
];
